export default {
  white: '#FFFFFF',
  black: '#000000',

  //Grey
  grey: {
    1: '#FCFCFC',
    2: '#F8F8F8',
    3: '#F3F3F3',
    4: '#EDEDED',
    5: '#E8E8E8',
    6: '#E2E2E2',
    7: '#DBDBDB',
    8: '#C7C7C7',
    9: '#8F8F8F',
    10: '#858585',
    11: '#6F6F6F',
    12: '#171717',
  },
  //Crimsom
  crimson: {
    1: '#FFFCFD',
    2: '#FFF7FB',
    3: '#FEEFF6',
    4: '#FCE5F0',
    5: '#F9D8E7',
    6: '#F4C6DB',
    7: '#EDADC8',
    8: '#E58FB1',
    9: '#E93D82',
    10: '#E03177',
    11: '#D31E66',
    12: '#3D0D1D',
  },
  //Indigo
  indigo: {
    1: '#FDFDFE',
    2: '#F8FAFF',
    3: '#F0F4FF',
    4: '#E6EDFE',
    5: '#D9E2FC',
    6: '#C6D4F9',
    7: '#AEC0F5',
    8: '#8DA4EF',
    9: '#3E63DD',
    10: '#3A5CCC',
    11: '#3451B2',
    12: '#101D46',
  },
  //Green
  green: {
    1: '#FBFEFC',
    2: '#F2FCF5',
    3: '#E9F9EE',
    4: '#DDF3E4',
    5: '#CCEBD7',
    6: '#B4DFC4',
    7: '#92CEAC',
    8: '#5BB98C',
    9: '#30A46C',
    10: '#299764',
    11: '#18794E',
    12: '#153226',
  },
  //Red
  red: {
    1: '#FFFCFC',
    2: '#FFF8F8',
    3: '#FFEFEF',
    4: '#FFE5E5',
    5: '#FDD8D8',
    6: '#F9C6C6',
    7: '#F3AEAF',
    8: '#EB9091',
    9: '#E5484D',
    10: '#DC3D43',
    11: '#CD2B31',
    12: '#381316',
  },
  //Yellow
  yellow: {
    1: '#FDFDF9',
    2: '#FFFCE8',
    3: '#FFFBD1',
    4: '#FFF8BB',
    5: '#FEF2A4',
    6: '#F9E68C',
    7: '#EFD36C',
    8: '#EBBC00',
    9: '#F5D90A',
    10: '#F7CE00',
    11: '#946800',
    12: '#35290F',
  },
};
